import { configureStore } from '@reduxjs/toolkit';
import authSliceReducer from './features/authSlice';
import sidebarSlice from './features/sidebarSlice';

export const store = configureStore({
    reducer: {
        auth: authSliceReducer,
        sidebar: sidebarSlice
    },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;